module.exports = __webpack_public_path__ + "static/media/lock-icon.8592c5a9.svg";